// Define enum for notification types
enum MessageType {
    SHARE_OBJECT_SUBMITTED = 'SHARE_OBJECT_SUBMITTED',
    SHARE_ITEM_REQUEST = 'SHARE_ITEM_REQUEST',
    SHARE_OBJECT_APPROVED = 'SHARE_OBJECT_APPROVED',
    SHARE_OBJECT_REJECTED = 'SHARE_OBJECT_REJECTED',
    SHARE_OBJECT_PENDING_APPROVAL = 'SHARE_OBJECT_PENDING_APPROVAL',
    DATASET_VERSION = 'DATASET_VERSION',
}

interface NotificationItem {
    created: string;
    is_read: boolean;
    message: string;
    notificationUri: string;
    target_uri: string;
    type: MessageType;
}

interface ListNotifications {
    nodes: NotificationItem[];
    count: number;
    page: number;
    pages: number;
}

interface NotificationsResponse {
    errors?: string[];
    data: {
        listNotifications: ListNotifications;
    };
}

export type { NotificationItem, ListNotifications, NotificationsResponse };

export { MessageType };
